module.exports = __webpack_public_path__ + "static/img/welcome.5dd66ee6.png";